<template>
    <div>
      <b-overlay :show="showOverlay" rounded="sm">
        <md-field>
            <label>{{$t('Account ID')}}</label>
            <md-input v-model.number="toAccountID"></md-input>
            <span class="md-suffix">
                <md-button class="md-raised" @click="checkAccountExists" style="margin: 0rem 0rem 1rem;">{{$t('Check')}}</md-button>
            </span>
        </md-field>
        <modal-ok-cancel @save="transferSerivces" @cancel="close" size="md" :saveButtonLabel="$t('Transfer')"/>
      </b-overlay>
    </div>
</template>

<script>
export default {
  props: {
    account_id: 0
  },
  data () {
    return {
      showOverlay: false,
      toAccountID: 0
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    sendUpdate () {
      this.$emit('update')
    },
    async transferSerivces () {
      this.showOverlay = true
      this.$store.dispatch('Users/GET_ACCOUNT_ACC', this.toAccountID).then(response => {
        if (this.$store.getters['Users/ACCOUNT_ACC'].account_id) {
          let tmp = {
            'from_account_id': this.account_id,
            'to_account_id': this.toAccountID
          }
          this.$store.dispatch('Users/TRANSFER_SERVICE_LINKS', tmp).then(response => {
            if (response.status === 200) {
              setTimeout(this.sendUpdate, 2000)
              this.showOverlay = false
              this.$root.$emit('makeToasts')
              this.close()
            } else {
              setTimeout(this.sendUpdate, 2000)
              this.showOverlay = false
              this.$root.$emit('makeToasts', 'danger', response.data.error, this.$t('Error'))
            }
          })
        } else {
          this.showOverlay = false
          this.$root.$emit('makeToasts', 'danger', this.$t('Account') + ' ' + this.$t('Not found'), this.$t('Error'))
        }
      })
    },
    checkAccountExists () {
      this.$store.dispatch('Users/GET_ACCOUNT_ACC', this.toAccountID).then(response => {
        if (this.$store.getters['Users/ACCOUNT_ACC'].account_id) {
          this.$root.$emit('makeToasts')
        } else {
          this.$root.$emit('makeToasts', 'danger', this.$t('Account') + ' ' + this.$t('Not found'), this.$t('Error'))
        }
      })
    }
  },
  mounted () {
    this.$store.dispatch('Users/GET_ACCOUNT_ACC', null)
    this.isAccountExists = false
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/detail/serviceLinks/formTransferServices.vue